import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getTitleStyles = (theme: Theme) =>
    css({
        marginBottom: theme.spacing(0.5),
    });

export const getSubtitleStyles = (theme: Theme) =>
    css({
        marginBottom: theme.spacing(2),
    });

export const getPlatformsWrapperStyles = (theme: Theme) =>
    css({
        padding: theme.spacing(2),
        backgroundColor: theme.palette.gray.ultraLight,
        borderRadius: theme.borderRadius.M,

        [theme.mediaQuery('tablet')]: {
            padding: theme.spacing(3),
        },
    });

export const getPlatformsStyles = (theme: Theme) =>
    css({
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: theme.spacing(2),

        [theme.mediaQuery('tablet')]: {
            gap: theme.spacing(3),
        },
    });

export const getPhoneFieldStyles = (theme: Theme) =>
    css({
        marginTop: theme.spacing(2),

        [theme.mediaQuery('tablet')]: {
            marginTop: theme.spacing(3),
        },
    });

export const getNoStoreStyles = (theme: Theme) =>
    css({
        justifyContent: 'flex-start',
        maxWidth: '100%',
        marginTop: theme.spacing(2),
    });

export const getNoStoreContentStyles = (theme: Theme) =>
    css({
        marginLeft: theme.spacing(2),

        p: {
            margin: 0,
        },
    });

export const getButtonStyles = (theme: Theme) =>
    css({
        justifyContent: 'center',
        marginTop: theme.spacing(3),

        [theme.mediaQuery('tablet')]: {
            alignSelf: 'flex-end',
        },
    });
